import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zBom2PositionSettings = z.object({
  nameId: zUid,
  materialTypeId: zUid,
  materialLocationId: zUid,
  materialSubtypeId: zUid,
  imageId: zUid,
  locationId: zUid,
  trimSizeId: zUid,
  amountId: zUid,
  commentId: zUid,
  qualityDetailsId: zUid,
  linkToBomPositionColorModelsId: zUid,
});
export type ZBom2PositionSettings = z.infer<typeof zBom2PositionSettings>;

export const zBom2SupplierSettings = z.object({
  nameId: zUid,
});
export type ZBom2SupplierSettings = z.infer<typeof zBom2SupplierSettings>;

export const zBom2ColorSettings = z.object({
  linkToModelId: zUid,
  colorModelArticleId: zUid,
  linkToColorInternalId: zUid,
});
export type ZBom2ColorSettings = z.infer<typeof zBom2ColorSettings>;

export const zBom2ColorModelSettings = z.object({
  linkToBomPositionId: zUid,
  linkToColorModelId: zUid,
  linkToColorId: zUid,
  colorManualId: zUid,
  colorReferenceId: zUid,
});
export type ZBom2ColorModelSettings = z.infer<typeof zBom2ColorModelSettings>;

export const zBom2Settings = z.object({
  objectServiceId: zUid,
  bomObjectId: zUid,
  positionObjectId: zUid,
  colorObjectId: zUid,
  colorModelObjectId: zUid,
  supplierObjectId: zUid,
  materialObjectId: zUid,
  positionAttributes: zBom2PositionSettings,
  supplierAttributes: zBom2SupplierSettings,
  colorAttributes: zBom2ColorSettings,
  bomPosColorModelAttributes: zBom2ColorModelSettings,
});
export type ZBom2Settings = z.infer<typeof zBom2Settings>;

// summary

export const zBom2SummaryRow = z.object({
  id: zUid,
  name: z.string().nullable(),
  supplierId: zUid.nullable(),
  supplierName: z.string().nullable(),
});

export type ZBom2SummaryRow = z.infer<typeof zBom2SummaryRow>;

export const zBom2Supplier = z.object({
  id: zUid,
  name: z.string().nullable(),
  country: z.string().nullable(),
  address: z.string().nullable(),
});
export type ZBom2Supplier = z.infer<typeof zBom2Supplier>;

export const zBom2SupplierResponse = z.object({
  content: zBom2Supplier.array(),
  totalElements: z.number(),
});
export type ZBom2SupplierResponse = z.infer<typeof zBom2SupplierResponse>;
